<template>
    <div id="slider" class="rs-slider load">
    <div class="tp-banner-container">
    <div class="tp-banner" >
    <ul>
    <li data-delay="7000" v-for="result in results" v-bind:key="result.id" v-bind:rid="result.id" data-height="500" data-transition="fade" data-slotamount="7" data-masterspeed="2000">
        <div class="elements">
            <div class="tp-caption lfl"
                data-x="-30"
                data-y="0"
                data-speed="1000"
                data-start="1500"
                data-easing="Power4.easeOut"
                data-endspeed="500"
                data-endeasing="Power1.easeIn"
                style="z-index: 2">
                    <img  v-onload="result.image_path" v-on:click="showZoom(result.image_path);" style="cursor: zoom-in;" v-bind:alt="result.title">
            </div>
        </div>
        <img src="img/content/slider/rs-slider5-bg.png" alt="" data-bgfit="cover" data-bgposition="center top" data-bgrepeat="no-repeat">
        <img  data-bgfit="cover"  data-bgposition="center top" data-bgrepeat="no-repeat">
    </li>
    </ul>
        <div class="tp-bannertimer"></div>
        </div>
    </div>

    <div id="divZoom" class="fadeMe hide" style="padding-top: 50px;" >
        <span class="title" style="color: rgb(217, 145, 156); margin-left: 20px; margin-top: 10px; font-weight: normal; font-size: 22px; font-family: Arimo, sans-serif;"><strong>{{results.title}}</strong></span>
        <span class="pull-right">
        <button class="btn-small pull-right" style="margin-right:10px;opacity:0.4;background: #fff;color:#000" onclick="$('#divZoom').hide();"><i class="fa fa-times"></i></button>
        </span>
        <iframe id="ifr" src="'vendor/zoom.html?img=images/no-image.jpg'" style="width:100%;height:100%;overflow:visible;"></iframe>
      </div>


    </div>
</template>    
<script>
import Vue from 'vue'
import $ from 'jquery'
import Common from '@/common.js'
import OnLoad from 'vue-onload'

Vue.use(OnLoad);

export default {
  name: 'MainBanner',
  props: {
    msg: String
  },data: function(){
	return {
		results: {"id": "0","activate":"active","title": "No Banner","image_path":"holder.js/400x150?bg=FF8C00&text=Image%202" }
	}
	},mounted: function() {
		Common.callServerFunction("Banner/BannerController::Get",this.get_response,{},"Banner");
		},methods:{
	get_response:function(response)
	{	
		var rdata = JSON.parse(response);
		this.results = rdata;

        var jimage = [];
        rdata.forEach((item) => {
            //console.log(item.image_path + " - " + index);
            jimage.push(item.image_path)
        });

        this.preload = false
        this.$nextTick(function() {
          this.$images.preload(jimage,
            //(completed, progress) => {
            (completed) => {
              // progress indicator from 0 (no image loaded yet) to 1 (all images loaded)
              //console.log(Math.round(progress * 100))
              // completed = true when all images are loaded
              if (completed) {
                this.preload = true
                //console.log(completed);
                console.log(jimage[0]);
                $("#ifr").attr("src",encodeURI("vendor/zoom.html?img=" + jimage[0].replace(Common.siteUrl + "resize/timthumb.php?src=","")));
                eval('loadFunctions();loadSlider();');
              }
            }
          )
        })

        
        //$(".item").eq(0).addClass('item active');
        
        
                 //$.get('./js/main.js', function(data) {
                //eval(data);
                //eval('setTimeout(loadFunctions(),1000);');
        
        //});

        Common.stopAjaxLoader();
	},showZoom: function(img)
{
  
  // this.$refs.zoomer.reset();
  //$("#imgItemZoom").attr("src",img);
    $("#ifr").attr("src",encodeURI("vendor/zoom.html?img="+img.replace(Common.siteUrl + "resize/timthumb.php?src=","")));
  $("#divZoom").show();

}
	
},loadOnMount: function() {
        
		//alert(123);
         //$.get('./js/main.js', function(data) {
        //eval(data);
        
        //});

    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
